import React, { PureComponent } from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import { SELECT_REFETCH_DELAY } from 'core/uiConstants';
import debounce from 'lodash/debounce';
import withIngredients from '../../../graphql/hocs/emr/withIngredients';

@withIngredients
class AllergenSelector extends PureComponent {
  static propTypes = {
    initialAllergens: PropTypes.arrayOf(PropTypes.object),
    onChange: PropTypes.func,
    onSelectedAllergen: PropTypes.func,
    onGetIngredients: PropTypes.func.isRequired,
    value: PropTypes.string, // eslint-disable-line react/require-default-props
  };

  static defaultProps = {
    onChange: () => undefined,
    onSelectedAllergen: () => undefined,
    initialAllergens: [],
  };

  constructor(props) {
    super(props);
    const { value } = props;
    this.state = {
      allergens: [],
      defaultValue: value,
    };
  }

  componentDidMount() {
    const { value } = this.props;
    if (!value) {
      this.loadAllergens();
    }
  }

  componentDidUpdate(prevProps) {
    const { initialAllergens: prevInitialRxTerms } = prevProps;
    const { initialAllergens } = this.props;
    if (initialAllergens.length && !prevInitialRxTerms.length) {
      this.setState({ allergens: initialAllergens });
    }
  }

  handleAllergenChange = value => {
    const { onChange, onSelectedAllergen } = this.props;
    const { allergens } = this.state;
    const allergen = allergens.find(a => a.rxcui === value);
    onChange(value);
    onSelectedAllergen(allergen);
  };

  loadAllergens = async searchString => {
    const { onGetIngredients } = this.props;
    const variables = { limit: 20 };
    if (searchString) {
      variables.searchString = searchString;
    }
    const data = await onGetIngredients(variables);
    this.setState({ allergens: data.nodes });
  };

  render() {
    const { defaultValue, allergens } = this.state;

    return (
      <Select
        filterOption={false}
        showSearch
        placeholder="Select allergen..."
        onSearch={debounce(this.loadAllergens, SELECT_REFETCH_DELAY)}
        onSelect={this.handleAllergenChange}
        defaultValue={defaultValue}
      >
        {allergens.map(({ rxcui, description }) => (
          <Select.Option key={rxcui} value={rxcui}>
            <div id={`cds-option-${rxcui}`}>{`${rxcui} | ${description}`}</div>
          </Select.Option>
        ))}
      </Select>
    );
  }
}

export default AllergenSelector;
